import BaseDocumentRequest from "../../components/BaseDocumentRequest/BaseDocumentRequest";
import { cosConfig } from "../../components/BaseDocumentRequest/config/cosConfig";

const CertificateOfService = () => {
  return <BaseDocumentRequest {...cosConfig} />;
};

export default CertificateOfService;
